import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export type GroupBy = 'transaction' | null;

export interface StartDonationExportArgs {
  clientId: number;
  start_date: string;
  end_date: string;
  recipients_to_include: string[];
  group_by: GroupBy;
}

export const donationExportApi = createApi({
  reducerPath: 'donationExportApi',
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    startDonationExport: builder.mutation<string, StartDonationExportArgs>({
      query: ({ clientId, start_date, end_date, recipients_to_include, group_by }) => ({
        url: '/admin/donation/download_request',
        method: 'POST',
        body: {
          start_date,
          end_date,
          recipients_to_include,
          group_by,
          client_id: clientId,
        },
      }),
      transformResponse: (response: { signed_url?: string }) => response.signed_url || '',
    }),
  }),
});

export const { useStartDonationExportMutation } = donationExportApi;
